module.exports = __webpack_public_path__ + "static/media/horizontal-rule.0a1aa134.svg";